import { axiosInstance } from "./apiInstance";

export const getGroupData = ({ group_id }) => {
  const response = axiosInstance.get(`/api/inkle/company/group/${group_id}/`);
  return response;
};
